import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {
    TbAlertTriangle,
    TbArrowBadgeLeft,
    TbMoneybag,
    TbSquareRoundedMinus,
    TbSquareRoundedPlusFilled
} from "react-icons/tb";
import Header from "../../Layouts/Header";
import {
    BiCategoryAlt,
    BiMapPin,
    BiMoney,
    BiSolidCoinStack,
} from "react-icons/bi";
import Loading from "../../Layouts/Loading";
import {GiTakeMyMoney, GiTwoCoins} from "react-icons/gi";
import {CiPercent} from "react-icons/ci";
import {
    MdAddLocation,
    MdOutlineRadioButtonChecked,
    MdOutlineRadioButtonUnchecked
} from "react-icons/md";
import Toast from "../../Components/Toast";
import {TfiCup} from "react-icons/tfi";
import {LiaMoneyCheckAltSolid} from "react-icons/lia";

const currencyFormat = Intl.NumberFormat('en-US');
export default function Cart() {
    const navigate = useNavigate();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [cart, setCart] = React.useState([]);
    const [items, setItems] = React.useState([]);
    const [addresses, setAddresses] = React.useState([]);
    const [addressId, setAddressId] = React.useState(0);
    const [cashPay, setCashPay] = React.useState(-1);
    const [vendor, setVendor] = React.useState([]);

    React.useEffect(() => {
        LoadCart();
        const params = {
            count: 15,
            page: 1,
            list: 1
        }

        let vendorID = window.localStorage.getItem("vendorID");

        API.getVendor(vendorID)
            .then((response) => {
                setVendor(response.data);
                if (response.data.cheque_deadline < 1) {
                    setCashPay(1)
                }
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

        API.getAddresses(params)
            .then((response) => {
                setAddresses(response.data);

            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)
    }, []);

    const LoadCart = () => {
        setIsLoaded(false);
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        let vendorID = window.localStorage.getItem("vendorID");

        if (cartItems) {
            setCart(cartItems)
        }
        const request = {
            cart: cartItems,
            list: 1,
            vendor: vendorID
        }

        API.getCart(request)
            .then((response) => {
                setItems(response);
                setIsLoaded(true);
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }
    const onPlusClick = (productID) => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        let count = 1;
        if (cartItems) {
            const find_item = cartItems.find(x => x.item === productID);
            if (find_item) {
                count = find_item.count + 1;
                const objIndex = cartItems.findIndex((obj => obj.item === productID));
                cartItems[objIndex].count = count;
            } else {
                cartItems.push({'item': productID, 'count': count})
            }
        }
        if (!cartItems) { //Object.keys(this.state.markets).length < 1
            cartItems = [];
            cartItems.push({'item': productID, 'count': count})
        }
        setCart(cartItems);
        window.localStorage.setItem("cart", JSON.stringify(cartItems));

        LoadCart()

    }

    const onMinusClick = (productID) => {
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        if (cartItems) {
            const find_item = cartItems.find(x => x.item === productID);
            if (find_item) {
                const count = find_item.count;
                const objIndex = cartItems.findIndex((obj => obj.item === productID));
                if (count > 1) {
                    cartItems[objIndex].count = count - 1;
                } else {
                    cartItems.splice(objIndex, 1)
                }
                setCart(cartItems)
                window.localStorage.setItem("cart", JSON.stringify(cartItems));
                LoadCart()
            }
        }

    }

    const getItemCartCount = (productID) => {
        const find_item = cart.find(x => x.item === productID);
        if (find_item) {
            return (find_item.count)
        } else {
            return 0
        }
    }

    const onStoreOrder = () => {
        if(cashPay < 0) {
            toast.error('لطفا نوع پرداخت (نقدی یا چکی) را مشخص کنید');
            return false;
        }
        setIsLoaded(false);
        let cartItems = JSON.parse(window.localStorage.getItem("cart"));
        let vendorID = window.localStorage.getItem("vendorID");

        const request = {
            cart: cartItems,
            vendor_id: vendorID,
            address_id: addressId,
            is_cash: cashPay,
            order_description: '',
        }

        API.storeOrder(request)
            .then((response) => {
                toast.success(response.message);
                window.localStorage.clear();
                setTimeout(() => {
                    window.location.replace(`/orders/`); //${response.data.id}
                }, 1500)
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }


    return (
        <React.Fragment>
            <Toast/>
            <Header title='جزئیات سفارش' hasBack={true}/>
            {
                !isLoaded && <Loading/>
            }
            <section className="container-fluid mt-3 rtl py-5 ">
                {
                    items.totalPayable < vendor.minimum_order_amount &&

                    <div className="row">
                        <div className="col-12">
                            <div className="alert alert-danger text-small-1">
                                <TbAlertTriangle className='text-big-5 mx-2 mb-1 fw-bold '/>
                                حداقل مبلغ خرید از این تامین کننده
                                {" "}
                                {currencyFormat.format(vendor.minimum_order_amount)}
                                {" "}
                                ریال
                                می باشد
                            </div>
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-12 home-separator-text ">
                        <BiCategoryAlt className='mx-2'/>
                        اقلام پیش فاکتور
                    </div>
                </div>
                {
                    isLoaded && items.items.map(product => {

                            return (
                                <div className="row cart-product-row mx-2 p-2 border-bottom rounded bg-white " key={product.id}>
                                    <div className="col-2 p-0">
                                        <img src={product.cover_image} alt={product.name} className='w-100'/>
                                    </div>
                                    <div className="col-9 title text-big-2 ">

                                        {product.name.substring(0, 25)}
                                        {
                                            product.name.length > 25 ? '...' : ''
                                        }
                                        <div className="  price-container">
                                            {product.discount > 0 ?
                                                <span className='discount ms-2'>

                                                 با                                          &nbsp;
                                                    <strong className='text-success'>{product.discount}
                                                        %
                                         </strong>
                                                    &nbsp;

                                                    تخفیف
                                     </span> : ''
                                            }
                                            <span className='price-with-discount'>
                                              {currencyFormat.format(product.discountedPrice)}

                                        </span>
                                            <span className='price mx-2'>
                                            ریال
                                        </span>
                                        </div>
                                    </div>


                                    <div className="col-12 px-0 mx-0 mt-3 ">
                                        <div className='float-end text-small-1 fw-bold text-secondary pt-2 opacity-75 '>
                                            {currencyFormat.format(product.discountedPrice * getItemCartCount(product.id))}
                                            <span className='price mx-2'>
                                            ریال
                                        </span>
                                        </div>
                                        <div className="add-minus-products text-start">

                                            {
                                                getItemCartCount(product.id) > 0 ?
                                                    <span className="add-product-icon text-secondary "
                                                          onClick={() => {
                                                              onMinusClick(product.id);

                                                          }}>
                                         <TbSquareRoundedMinus/>

                                     </span> : <span>&nbsp;</span>
                                            }

                                            {
                                                getItemCartCount(product.id) > 0 ?
                                                    <span className="px-2">
                                    <input type="tel" className="bg-white" value={getItemCartCount(product.id)}
                                           readOnly/>
                                </span> : <span>&nbsp;</span>
                                            }

                                            <span className="add-product-icon   "
                                                  onClick={() => {
                                                      onPlusClick(product.id);

                                                  }}>
                                         <TbSquareRoundedPlusFilled className='text-secondary-color'/>
                                    </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                    )
                }

                <div className="row mt-4 ">
                    <div className="col-12 home-separator-text ">
                        <BiMoney className='mx-2'/>
                        مبالغ پیش فاکتور
                    </div>
                </div>
                <div className="row mt-1 text-small-2 text-muted ">
                    <div className="col-1">
                        &nbsp;
                    </div>
                    <div className="col-1">
                        <BiSolidCoinStack className='mx-2'/>
                    </div>
                    <div className="col-4">
                        جمع کل
                    </div>
                    <div className="col-5 text-start ">
                        {currencyFormat.format(items.totalPrice)}
                        &nbsp;
                        ریال
                    </div>
                </div>
                <div className="row mt-2 text-small-2 text-success ">
                    <div className="col-1">
                        &nbsp;
                    </div>
                    <div className="col-1">
                        <CiPercent className='mx-2'/>
                    </div>
                    <div className="col-4">
                        تخفیف
                    </div>
                    <div className="col-5 text-start ">
                        {currencyFormat.format(items.totalDiscount)}
                        &nbsp;
                        ریال
                    </div>
                </div>
                <div className="row mt-2 text-small-2 text-success ">
                    <div className="col-1">
                        &nbsp;
                    </div>
                    <div className="col-1">
                        <CiPercent className='mx-2'/>
                    </div>
                    <div className="col-4">
                        تخفیف حجمی
                    </div>
                    <div className="col-5 text-start ">
                        {currencyFormat.format(items.discountPriceThreshold)}
                        &nbsp;
                        ریال
                    </div>
                </div>
                <div className="row mt-2 text-small-2 text-danger ">
                    <div className="col-1">
                        &nbsp;
                    </div>
                    <div className="col-1">
                        <TbMoneybag className='mx-2'/>
                    </div>
                    <div className="col-4">
                        مالیات
                    </div>
                    <div className="col-5 text-start ">
                        {currencyFormat.format(items.totalTax)}
                        &nbsp;
                        ریال
                    </div>
                </div>
                <div className="row mt-2 text-small-2 text-primary-color border-bottom pb-3 ">
                    <div className="col-1">
                        &nbsp;
                    </div>
                    <div className="col-1">
                        <TfiCup className='mx-2'/>
                    </div>
                    <div className="col-4">
                        امتیاز دریافتی کل
                    </div>
                    <div className="col-5 text-start ">
                        {items.totalScore}
                        &nbsp;
                        امتیاز
                    </div>
                </div>
                <div className="row mt-2 text-small-1 text-muted ">
                    <div className="col-1">
                        &nbsp;
                    </div>
                    <div className="col-1">
                        <GiTwoCoins className='mx-2'/>
                    </div>
                    <div className="col-4">
                        مبلغ فاکتور
                    </div>
                    <div className="col-5 text-start fw-bold ">
                        {currencyFormat.format(items.totalPayable)}
                        &nbsp;
                        ریال
                    </div>
                </div>

                {vendor.is_selected > 0 && items.wallet_inventory > vendor.max_use_prize &&
                <div className="row mt-5">
                    <div className="col-12">
                        <div className="festival-banner card shadow-sm mb-3">
                            <div className="festival-badge">جشنواره</div>
                            <div className="card-body">
                                <p className="mb-0 fw-bold text-small-2 text-justify">
                                    <div className=' fw-bold text-danger' style={{fontSize: '12px'}}>
                                        اگر پیش از این برای این تامین کننده هدیه جشنواره را دریافت نکرده باشید:
                                    </div>
                                    در صورت ثبت سفارش
                                    {" "}
                                    {currencyFormat.format(vendor.max_use_prize)}
                                    {" "}
                                    ریال
                           از مبلغ فاکتور بابت هدیه خرید در جشنواره‌ کسر خواهد شد.


                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                }

                <div className="row mt-5 ">
                    <div className="col-6 home-separator-text ">
                        <BiMapPin className='mx-2'/>
                        آدرس ارسال
                    </div>
                    <div className="col-6 text-start text-small-3 text-secondary-color px-4"
                         onClick={() => navigate('/add-address')}
                    >
                        <MdAddLocation className='ms-2'/>
                        افزودن آدرس جدید

                    </div>
                </div>
                {isLoaded && (
                    <div className="address-selection-container my-5">
                        {addresses.map((address) => {
                            const isSelected = address.id === addressId;
                            return (
                                <div
                                    key={address.id}
                                    onClick={() => setAddressId(address.id)}
                                    className={`custom-address-card d-flex align-items-center p-3 mb-3 ${
                                        isSelected ? "active-address" : ""
                                    }`}
                                >
                                    <div className="icon-wrapper me-3">
                                        {isSelected ? (
                                            <MdOutlineRadioButtonChecked className="text-success fs-4"/>
                                        ) : (
                                            <MdOutlineRadioButtonUnchecked className="text-muted fs-4"/>
                                        )}
                                    </div>
                                    <div className="address-content flex-grow-1">
                                        <h6 className="mb-1 fw-bold text-dark">{address.title}</h6>
                                        <p className="mb-0 text-secondary small">{address.address}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}


                <div
                    className={
                        cashPay === 1 ? "row mt-4 mx-2 py-3 px-0 bg-success-subtle rounded border border-success" :
                            "row mt-4 mx-2 py-3 px-0 bg-white rounded border border-secondary opacity-75"
                    }
                    onClick={
                        () => {
                            setCashPay(1)
                        }
                    }
                >
                    <div className="col-2">
                        <GiTakeMyMoney className='text-big-3m text-primary'/>
                    </div>
                    <div className="col-10">
                        <span className='fw-bold'>
                            پرداخت نقدی
                            {" "}
                            {vendor.cash_discount_percent > 0 &&

                                <>

                                    با تخفیف
                                    {" "}
                                    <strong className='text-success'>
                                        {vendor.cash_discount_percent}
                                    </strong>
                                    {" "}
                                    درصد
                                    {" "}
                                </>
                            }
                        </span>
                        <div className='text-small-2 mt-2 text-start fw-bold'>
                            مبلغ قابل پرداخت
                            :
                            {" "}
                            {currencyFormat.format(items.totalPayable * (1 - (vendor.cash_discount_percent / 100)))}
                            {" "}
                            ریال

                        </div>
                    </div>
                </div>
                {
                    vendor.cheque_deadline > 0 &&

                    <div className={
                        cashPay === 0 ? "row my-2 mb-5 mx-2 py-3 px-0 bg-success-subtle rounded border border-success" :
                            "row my-2 mb-5 mx-2 py-3 px-0 bg-white rounded border border-secondary opacity-75"
                    }
                         onClick={
                             () => {
                                 setCashPay(0)
                             }
                         }
                    >


                        <div className="col-2 text-end">
                            <LiaMoneyCheckAltSolid className='text-big-3m text-primary'/>
                        </div>
                        <div className="col-10">
                        <span className='fw-bold'>
                            تسویه با چک مدت
                            &nbsp;
                            <strong className='text-success'>
                                {vendor.cheque_deadline}
                            </strong>
                            &nbsp;

                            روزه
                        </span>
                            <div className='text-small-2 mt-2 text-start fw-bold'>
                                مبلغ چک
                                :
                                &nbsp;
                                {currencyFormat.format(items.totalPayable)}
                                &nbsp;
                                ریال

                            </div>
                        </div>
                    </div>
                }
                {
                    items.totalPayable >= vendor.minimum_order_amount ?
                        <div className="row">

                            <div className="col-12 p-2 fixed-bottom max-w-lg">
                                <button
                                    className="btn btn-warning text-end text-small-1 text-semi-big  w-100 p-2 fw-bold  pe-4 border-0"
                                    onClick={onStoreOrder}
                                >
                                    ثبت سفارش
                                    <span className="badge  p-2 float-start">
                                         <span className='text-white-50 px-2 '>
                                                {window.localStorage.getItem("companyName")}
                                           </span>
<TbArrowBadgeLeft className='text-big-3'/>
                    </span>
                                </button>
                            </div>
                        </div>
                        :
                        ""
                }

            </section>
        </React.Fragment>

    );
}

